<template>
  <div class="app-object">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="'input-group-' + i"
        class="input-group"
        @click="removeError(i)">

        <el-select
          v-model="valueLocal[i]"
          :key="'userId-' + i"
          filterable
          clearable
          remote
          style="width: 100%"
          :remote-method="getSuggestions"
          :loading="loading">
          <el-option
            v-for="(s, j) in suggestions"
            :key="`object-option-${i}-${j}`"
            :label="s.title"
            :value="s.value">
            <div v-if="s.title" class="title">{{ s.title }}</div>
            <div v-if="s.author" class="author">{{ s.author }}</div>
          </el-option>
        </el-select>

        <div v-if="error[i]" class="ait_message ait_message--error">
          {{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import axios from 'axios';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
      loading: false,
      suggestions: [],
    };
  },

  methods: {

    getSuggestions(query) {
      if (query) {
        this.loading = true;
        axios.get('objects/search', { params: { q: query } }).then((response) => {
          this.loading = false;
          this.suggestions = [];
          response.data.Objects.forEach((o, i) => {
            this.suggestions.push({});
            this.suggestions[i].value = o.ObjectId;
            this.suggestions[i].title = o.Title;
            this.suggestions[i].author = `${o.Authors[0].Surname} ${o.Authors[0].Name} ${o.Authors[0].Patronymic}`;
            this.suggestions[i].author += `, ${o.Organizations[0].Organization}`;
          });
        });
      } else {
        this.suggestions = [];
      }
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppObject.vue